module.exports = __webpack_public_path__ + "img/combojetvac_driving.9a555023.svg";